import React, { useState, useCallback, useEffect, useContext } from 'react';
import Switch from "react-switch";
import Moment from 'react-moment';

//httpClient
import ChartsClient from './../../httpClient/Charts'; 

//Context API for User Info
import { InfoContext } from "./../../context/InfoContext";

//react-bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Spinner from 'react-bootstrap/Spinner';

//styling
import './ChartDetails.css';

import ChartQuestions from './ChartQuestions';
// import PDFViewer from './components/PDFViewer';

const ChartDetails = (props) => {
    //current user Info
    const { currentRecord, reloadChartsList } = props;
    const { info, setInfo } = useContext(InfoContext);
    const [formKey, setFormKey] = useState('COPA2020');
    const [currentRecordDetails, setCurrentRecordDetails] = useState(null); //Set Current Record variable
    const [loading, setLoading] = useState({currentRecordDetailsLoading: false, chartQuestionsLoading: false, formSubmission: false, currentChartUpdating: false});
    const [currentChartQuestions, setCurrentChartQuestions] = useState(null);
    const [statusMessage, setStatusMessage] = useState("");
    const [pdfFile, setPdfFile] = useState("");

    const updateLoading = useCallback((key,value) => {
        setLoading((loading)=>{
            return({
                ...loading,
                [key]: value
            });
        });
    },[]);

    useEffect(() => {
        // fetchChartPDF();
        setStatusMessage("Fetching chart details (Process usually takes 1 minute)...")
        fetchChartDetails();
        fetchChartQuestions();
        updateChartStatus();
    },[]);

    const fetchChartPDF = () => {

        setPdfFile("");
        setStatusMessage("Fetching Chart PDF...");
        updateLoading("currentRecordDetailsLoading",true);

        let params = {
            PCR_ID: currentRecord.PCR_ID,
            appName:  currentRecord.eRecord_03,
            username: info.email,
            caseNumber:  currentRecord.eResponse_03,
            integration: currentRecord.integration
        };

        ChartsClient.getChartPDF(params.PCR_ID, params.appName, params.username, params.caseNumber, params.integration)
        .then(data => {
            updateLoading("currentRecordDetailsLoading",false);
            setStatusMessage("");
            if(data.pdfExists) {
                setPdfFile(data.pcr);
            } else {
                setStatusMessage("Chart PDF not found, fetching Chart details (Process usually takes 1 minute)...");
                fetchChartDetails();
            }
        })
        .catch(err => {
            updateLoading("currentRecordDetailsLoading",false);
        });
    }

    
    const fetchChartDetails = () => {
        updateLoading("currentRecordDetailsLoading",true);
        ChartsClient.getChartDetails(currentRecord.PCR_ID, currentRecord.integration)
        .then(data => {
            updateLoading("currentRecordDetailsLoading",false);
            setCurrentRecordDetails(data);
            setStatusMessage("");
        })
        .catch(err => {
            updateLoading("currentRecordDetailsLoading",false);
            setStatusMessage("");
        });
    }

    const fetchChartQuestions = () => {
        updateLoading("chartQuestionsLoading",true);
        ChartsClient.getAllChartQuestions(formKey)
        .then(data => {
            updateLoading("chartQuestionsLoading",false);
            setCurrentChartQuestions(data);
        })
        .catch(err => {
            updateLoading("chartQuestionsLoading",false);
        });
      }
      
    const updateChartStatus = (payload) => {
        updateLoading("currentChartUpdating",true);
        let params = {
            PCR_ID: currentRecord.PCR_ID,
            incidentNumber: currentRecord.eResponse_03,
            employeeNumber: info.employeeNumber,
            email: info.email,
            Status: 'In Review',
            integration: currentRecord.integration,
            integrationIdentifier: currentRecord.integrationIdentifier
        };

        ChartsClient.updateChartStatus(params)
        .then(data => {
            updateLoading("currentChartUpdating",false);
        })
        .catch(err => {
            updateLoading("currentChartUpdating",false);
        });
      }

    const submitFormAnswers = (payload) => {

        let params = {
            ...payload,
            PCR_ID: currentRecord.PCR_ID,
            incidentNumber: currentRecord.eResponse_03,
            employeeNumber: info.employeeNumber,
            email: info.email,
            integration: currentRecord.integration,
            integrationIdentifier: currentRecord.integrationIdentifier
        };
        updateLoading("currentChartUpdating",true);
        ChartsClient.submitFormAnswers(params)
        .then(data => {
            //updateLoading("currentChartUpdating",false);
            reloadChartsList();
        })
        .catch(err => {
            //updateLoading("currentChartUpdating",false);
        });
     }

    const exitChartReview = () => { 
        updateLoading("currentChartUpdating",true);
        ChartsClient.exitChartFromReview(currentRecord.PCR_ID)
        .then(data => {
            //updateLoading("currentChartUpdating",false);
            reloadChartsList();
        })
        .catch(err => {
            //updateLoading("currentChartUpdating",false);
        });
    }

    const saveProgress = () => { 
        reloadChartsList();
    }

    const checkIfDateValid = (value) => {
        return !isNaN(Date.parse(value));
    }
        

    return(
            <div className="innerBody">
                <Container fluid>
                    <Row>
                        <Col fluid><h4 className="subtitle">{currentRecord.dAgency_03} ({currentRecord.integrationIdentifier}) - {currentRecord.eRecord_03} </h4></Col>
                        {loading.currentChartUpdating &&<Spinner animation="border" variant="primary" />}
                        {!loading.currentChartUpdating && <Col md="auto"><Button variant="info" onClick={()=>fetchChartQuestions()}>Start Over</Button></Col> }
                        {!loading.currentChartUpdating && <Col md="auto"><Button variant="primary" onClick={()=>saveProgress()}>Park Chart</Button></Col> }
                        {/* {!loading.currentChartUpdating && <Col md="auto"><Button variant="warning" onClick={()=>exitChartReview()}>Unpark Chart</Button></Col> } */}
                        {!loading.currentChartUpdating && <Col md="auto"><Button variant="danger" onClick={()=>exitChartReview()}>Exit Chart Review</Button></Col> }
                    </Row>            
                    <Row>
                        <Col xs={12} md={8}>
                        <hr />        

                            {loading.currentRecordDetailsLoading && <Spinner animation="border" variant="primary" />}
                            {statusMessage.length > 0 && <h4>{statusMessage}</h4>}

                            <div className="chart-body">

                                {pdfFile.length > 0 && 
                                    <div className="chart-innerBody">
                                        <p className="confidentiality-warning">***CONFIDENTIAL PATIENT PROTECTED INFORMATION***</p>
                                        <br />
                                        <p className="chart-header">Clinical Outcomes and Performance Analysis (CO/PA)</p>
                                        <br />
                                        {/* <PDFViewer pdfFile={pdfFile} />  */}
                                    </div>
                                }

                                { currentRecordDetails && <div className="chart-innerBody">
                                    <p className="confidentiality-warning">***CONFIDENTIAL PATIENT PROTECTED INFORMATION***</p>
                                    <br />
                                    <p className="chart-header">Clinical Outcomes and Performance Analysis (CO/PA)</p>

                                    <br />
                                    <h4 className="chart-subheader">Patient Information</h4>

                                    <Container>
                                        <Row className="dotted-row">   
                                            {/* <Col xs>ePatient.15</Col> */}
                                            <Col className="dotted-column">Age</Col>
                                            <Col>{currentRecordDetails.ePatient_15}</Col>
                                        </Row>
                                        <Row className="dotted-row">   
                                            {/* <Col xs>ePatient.16</Col> */}
                                            <Col className="dotted-column">Age in Units</Col>
                                            <Col>{currentRecordDetails.ePatient_16}</Col>
                                        </Row>
                                        <Row className="dotted-row">   
                                            {/* <Col xs>ePatient.17</Col> */}
                                            <Col className="dotted-column">Date of Birth</Col>
                                            <Col>{currentRecordDetails.ePatient_17}</Col>
                                        </Row>
                                        <Row className="dotted-row">   
                                            {/* <Col xs>ePatient.13</Col> */}
                                            <Col className="dotted-column">Gender</Col>
                                            <Col>{currentRecordDetails.ePatient_13}</Col>
                                        </Row>
                                        <Row className="dotted-row">   
                                            {/* <Col xs>eExam.01</Col> */}
                                            <Col className="dotted-column">Weight</Col>
                                            <Col>{currentRecordDetails.eExam_01}</Col>
                                        </Row>                                                                                                                                           
                                    </Container>
                                    <br />
                                    <br />
                                    <h4 className="chart-subheader">Call Type/Location/Disposition</h4>

                                    <Container>
                                        <Row className="dotted-row">   
                                            {/* <Col xs>eDispatch.01</Col> */}
                                            <Col className="dotted-column">Call Type</Col>
                                            <Col>{currentRecordDetails.eDispatch_01}</Col>
                                        </Row>    
                                        <Row className="dotted-row">
                                            {/* <Col xs>eDispatch.05</Col> */}
                                            <Col className="dotted-column">Response Type</Col>
                                            <Col>{currentRecordDetails.eResponse_24}</Col>
                                        </Row>    
                                        <Row className="dotted-row">
                                            {/* <Col xs>eDispatch.05</Col> */}
                                            <Col className="dotted-column">Response Mode</Col>
                                            <Col>{currentRecordDetails.eResponse_23}</Col>
                                        </Row>                                          
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eDisposition.12</Col> */}
                                            <Col className="dotted-column">Disposition</Col>
                                            <Col>{currentRecordDetails.eDisposition_12}</Col>
                                        </Row>    
                                        <Row className="dotted-row">    
                                            {/* <Col xs>ePayment.40</Col> */}
                                            <Col className="dotted-column">Urgency</Col>
                                            <Col>{currentRecordDetails.ePayment_40}</Col>
                                        </Row>    
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eResponse.07</Col> */}
                                            <Col className="dotted-column">Primary Role of the Unit</Col>
                                            <Col>{currentRecordDetails.eResponse_07}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eScene.09</Col> */}
                                            <Col className="dotted-column">Location Type</Col>
                                            <Col>{currentRecordDetails.eScene_09}</Col>
                                        </Row>    
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eDisposition.01</Col> */}
                                            <Col className="dotted-column">Destination</Col>
                                            <Col>{currentRecordDetails.eDisposition_01}</Col>
                                        </Row>    
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eDisposition.21</Col> */}
                                            <Col className="dotted-column">Type of Destination</Col>
                                            <Col>{currentRecordDetails.eDisposition_21}</Col>
                                        </Row>    
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eDisposition.22</Col> */}
                                            <Col className="dotted-column">Hospital In-Patient Destination</Col>
                                            <Col>{currentRecordDetails.eDisposition_22}</Col>
                                        </Row>    
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eDisposition.20</Col> */}
                                            <Col className="dotted-column">Dest. Determi</Col>
                                            <Col>{currentRecordDetails.eDisposition_20}</Col>
                                        </Row>    
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eResponse.09</Col> */}
                                            <Col className="dotted-column">Response Delay</Col>
                                            <Col>{currentRecordDetails.eResponse_09}</Col>
                                        </Row>    
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eResponse.10</Col> */}
                                            <Col className="dotted-column">Scene Delay</Col>
                                            <Col>{currentRecordDetails.eResponse_10}</Col>
                                        </Row>    
                                        <Row className="dotted-row">    
                                            {/* <Col xs>eResponse.11</Col> */}
                                            <Col className="dotted-column">Transport Delay</Col>
                                            <Col>{currentRecordDetails.eResponse_11}</Col>
                                        </Row>    
                                    </Container>


                                    <br />
                                    <br />
                                    <h4 className="chart-subheader">Response Times</h4>
                                    <Container>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.01</Col> */}
                                            <Col className="dotted-column">PSAP</Col> 
                                            <Col>{currentRecordDetails.eTimes_01 && checkIfDateValid(currentRecordDetails.eTimes_01) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_01}</Moment> : currentRecordDetails.eTimes_01}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.02</Col> */}
                                            <Col className="dotted-column">Disp. Nofieid</Col>
                                            <Col>{currentRecordDetails.eTimes_02 && checkIfDateValid(currentRecordDetails.eTimes_02) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_02}</Moment> : currentRecordDetails.eTimes_02}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.04</Col> */}
                                            <Col className="dotted-column">Unit Ackd</Col>
                                            <Col>{currentRecordDetails.eTimes_04 && checkIfDateValid(currentRecordDetails.eTimes_04) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_04}</Moment> : currentRecordDetails.eTimes_04}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.05</Col> */}
                                            <Col className="dotted-column">Enroute</Col>
                                            <Col>{currentRecordDetails.eTimes_05 && checkIfDateValid(currentRecordDetails.eTimes_05) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_05}</Moment> : currentRecordDetails.eTimes_05}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.06</Col> */}
                                            <Col className="dotted-column">At Scene</Col>
                                            <Col>{currentRecordDetails.eTimes_06 && checkIfDateValid(currentRecordDetails.eTimes_06) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_06}</Moment> : currentRecordDetails.eTimes_06}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.07</Col> */}
                                            <Col className="dotted-column">At Patient</Col>
                                            <Col>{currentRecordDetails.eTimes_07 && checkIfDateValid(currentRecordDetails.eTimes_07) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_07}</Moment> : currentRecordDetails.eTimes_07}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.09</Col> */}
                                            <Col className="dotted-column">Depart/Transport</Col>
                                            <Col>{currentRecordDetails.eTimes_09 && checkIfDateValid(currentRecordDetails.eTimes_09) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_09}</Moment> : currentRecordDetails.eTimes_09}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.11</Col> */}
                                            <Col className="dotted-column">Arrive Dest</Col>
                                            <Col>{currentRecordDetails.eTimes_11 && checkIfDateValid(currentRecordDetails.eTimes_11) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_11}</Moment> : currentRecordDetails.eTimes_11}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.12</Col> */}
                                            <Col className="dotted-column">Trasnfer of Care</Col>
                                            <Col>{currentRecordDetails.eTimes_12 && checkIfDateValid(currentRecordDetails.eTimes_12) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_12}</Moment> : currentRecordDetails.eTimes_12}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.13</Col> */}
                                            <Col className="dotted-column">In Service</Col>
                                            <Col>{currentRecordDetails.eTimes_13 && checkIfDateValid(currentRecordDetails.eTimes_13) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_13}</Moment> : currentRecordDetails.eTimes_13}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.15</Col> */}
                                            <Col className="dotted-column">In Quarters</Col>
                                            <Col>{currentRecordDetails.eTimes_15  && checkIfDateValid(currentRecordDetails.eTimes_15) ? <Moment format="YYYY-MM-DD HH:mm">{currentRecordDetails.eTimes_15}</Moment> : currentRecordDetails.eTimes_15}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            <Col className="dotted-column">Total Time On Scene</Col>
                                            <Col>{currentRecordDetails.eTimes_06 && 
                                                  currentRecordDetails.eTimes_09 && 
                                                  checkIfDateValid(currentRecordDetails.eTimes_06) &&
                                                  checkIfDateValid(currentRecordDetails.eTimes_09) ? <Moment diff={currentRecordDetails.eTimes_06} unit="minutes">{currentRecordDetails.eTimes_09}</Moment> : '--'} Minutes</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            <Col className="dotted-column">Total Time Transporting</Col>
                                            <Col>{currentRecordDetails.eTimes_09 && 
                                                  currentRecordDetails.eTimes_11 && 
                                                  checkIfDateValid(currentRecordDetails.eTimes_09) &&
                                                  checkIfDateValid(currentRecordDetails.eTimes_11) ? <Moment diff={currentRecordDetails.eTimes_09} unit="minutes">{currentRecordDetails.eTimes_11}</Moment> : '--'} Minutes</Col>
                                        </Row>
                                    </Container>

                                    <br />
                                    <br />
                                    <h4 className="chart-subheader">Provider Impression</h4>
                                    <Container>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.13</Col> */}
                                            <Col className="dotted-column">Primary Impression</Col>
                                            <Col>{currentRecordDetails.eSituation_11}</Col>
                                        </Row>
                                        <Row className="dotted-row">    
                                            {/* <Col md="auto">eTimes.15</Col> */}
                                            <Col className="dotted-column">Secondary Impression</Col>
                                            <Col>{currentRecordDetails.eSituation_12}</Col>
                                        </Row>                                                                                        
                                    </Container>

                                    <br />
                                    <br />
                                    <h4 className="chart-subheader">Patient Care Report Narrative</h4>
                                    {currentRecordDetails.eNarrative_01}

                                </div> }   

                                
                                { currentRecordDetails && <div className="chart-innerBodyAlt">
                                <br />
                                    <h4 className="chart-subheader">Procedures</h4>
                                    <table class="grid-table">
                                        <thead>
                                            <tr>    
                                                <th>Date/Time Procedure Performed</th>
                                                <th>Procedure Performed Prior to this Unit's EMS Care</th>
                                                <th>Procedure</th>
                                                <th>Number of Procedure Attempts</th>
                                                <th>Procedure Successful</th>
                                                <th>Procedure Complication</th>
                                                <th>Response to Procedure</th>
                                                <th>Role/Type of Person Performing the Procedure</th>
                                                <th>Procedure Authorization</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentRecordDetails.eProcedures && currentRecordDetails.eProcedures.map((procedure, key) => 
                                                <tr>  
                                                    <td>{procedure.eProcedures_01 && checkIfDateValid(procedure.eProcedures_01) ? <Moment format="YYYY-MM-DD HH:mm">{procedure.eProcedures_01}</Moment> : procedure.eProcedures_01}</td>
                                                    <td>{procedure.eProcedures_02}</td>
                                                    <td>{procedure.eProcedures_03}</td>
                                                    <td>{procedure.eProcedures_05}</td>
                                                    <td>{procedure.eProcedures_06}</td>
                                                    <td>{procedure.eProcedures_07}</td>
                                                    <td>{procedure.eProcedures_08}</td>
                                                    <td>{procedure.eProcedures_10}</td>
                                                    <td>{procedure.eProcedures_11}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    <br />                                
                                    <br />
                                    <h4 className="chart-subheader">Medications</h4>
                                    <table class="grid-table">
                                        <thead>
                                            <tr>    
                                                <th>Date/Time Medication Administered</th>
                                                <th>Medication Administered Prior to this Unit's EMS Care</th>
                                                <th>Medication Given</th>
                                                <th>Medication Administered Route</th>
                                                <th>Medication Dosage</th>
                                                <th>Medication Dosage Units</th>
                                                <th>Response to Medication</th>
                                                <th>Medication Complication</th>
                                                <th>Role/Type of Person Administering Medication</th>
                                                <th>Medication Authorization</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentRecordDetails.eMedications && currentRecordDetails.eMedications.map((medication, key) => 
                                                <tr>  
                                                    <td>{medication.eMedications_01 && checkIfDateValid(medication.eMedications_01) ? <Moment format="YYYY-MM-DD HH:mm">{medication.eMedications_01}</Moment> : medication.eMedications_01}</td>
                                                    <td>{medication.eMedications_02}</td>
                                                    <td>{medication.eMedications_03}</td>
                                                    <td>{medication.eMedications_04}</td>
                                                    <td>{medication.eMedications_05}</td>
                                                    <td>{medication.eMedications_06}</td>
                                                    <td>{medication.eMedications_07}</td>
                                                    <td>{medication.eMedications_08}</td>
                                                    <td>{medication.eMedications_10}</td>
                                                    <td>{medication.eMedications_11}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    <br />
                                    <br />
                                    <h4 className="chart-subheader">Vitals</h4>
                                    <table class="grid-table">
                                        <thead>
                                            <tr>    
                                                <th>Time</th>
                                                <th>PTA</th>
                                                <th>SBP/DBP</th>
                                                <th>MAP</th>
                                                <th>BP Method</th>
                                                <th>HR</th>
                                                <th>Pulse Rhythm</th>
                                                <th>HR Method</th>
                                                <th>Resp</th>
                                                <th>Effort</th>
                                                <th>SpO2</th>
                                                <th>ETCO2</th>
                                                <th>Pain Score</th>
                                                <th>Blood Glucose</th>
                                                <th>EKG</th>
                                                <th>GCS</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {currentRecordDetails.eVitals && currentRecordDetails.eVitals.map((vital, key) => 
                                            <tr>  
                                                <td>{ vital.eVitals_01 && checkIfDateValid(vital.eVitals_01) ? <Moment format="YYYY-MM-DD HH:mm">{vital.eVitals_01}</Moment> : vital.eVitals_01}</td>
                                                <td>{vital.eVitals_02}</td>
                                                <td>{vital.eVitals_06}/{vital.eVitals_07}</td>
                                                <td>{vital.eVitals_09}</td>
                                                <td>{vital.eVitals_08}</td>
                                                <td>{vital.eVitals_10}</td>
                                                <td>{vital.eVitals_13}</td>
                                                <td>{vital.eVitals_11}</td>
                                                <td>{vital.eVitals_14}</td>
                                                <td>{vital.eVitals_15}</td>
                                                <td>{vital.eVitals_12}</td>
                                                <td>{vital.eVitals_16}</td>
                                                <td>{vital.eVitals_27}</td>
                                                <td>{vital.eVitals_18}</td>
                                                <td>{vital.eVitals_03}</td>
                                                <td>{vital.eVitals_23}</td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>                                      
                                </div> } 
                    
                            </div>
                        </Col>
                        <Col xs={6} md={4}>
                        <hr />        

                            {loading.chartQuestionsLoading && <Spinner animation="border" variant="primary" />}

                            <div className="form-body">
                                {/* { JSON.stringify(currentChartQuestions)} */}
                                {!loading.chartQuestionsLoading && !loading.formSubmission && <ChartQuestions formKey={formKey} currentFormQuestions={currentChartQuestions} submitFormAnswers={submitFormAnswers} /> }
                            </div>

                        </Col>                    
                    </Row>
                </Container>
            </div>             
    );
};

export default ChartDetails;
